<input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;">
<ng-container *ngIf="fnolRequest">
  <div class="action-container">
    <div class="icon" *ngIf="isUnclosedTasks()">
      <mat-icon color="primary">pending_actions</mat-icon>
    </div>
    <button (click)="openTasksList()" color="primary"
            mat-raised-button>{{ 'fnol-request-side-bar.task_button' | translate }}
    </button>
    <div class="flex-placeholder" *ngIf="isUnclosedTasks()"></div>
  </div>

  <div>
    <mat-form-field>
      <mat-label>{{ 'fnol-request-side-bar.priority_label' | translate }}</mat-label>
      <mat-select [(ngModel)]="fnolRequest.priority" (selectionChange)="dropdownValueChanged()">
        <mat-option [value]="0">{{ 'fnol-request-side-bar.priority_normal' | translate }}</mat-option>
        <mat-option [value]="1">{{ 'fnol-request-side-bar.priority_high' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field>
      <mat-label>{{ 'fnol-request-side-bar.assignee_label' | translate }}</mat-label>
      <mat-select [(ngModel)]="fnolRequest.processingAssignee" (selectionChange)="dropdownValueChanged()">
        <mat-option value="-">{{ 'fnol-request-side-bar.assignee_unassigned' | translate }}</mat-option>
        <mat-option [value]="user.email" *ngFor="let user of usersList">{{ user.firstname }} {{ user.lastname }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="labels-container">
    <section>
      <mat-checkbox [checked]="isLabelChecked(tasksLabels.SIMPLE_CLAIM)"
                    (change)="checkLabel(tasksLabels.SIMPLE_CLAIM)">{{ 'fnol-request-side-bar.labels.simple_claim' | translate }}
      </mat-checkbox>
      <mat-checkbox [checked]="isLabelChecked(tasksLabels.MULTIPLE_CLAIMS)"
                    (change)="checkLabel(tasksLabels.MULTIPLE_CLAIMS)">{{ 'fnol-request-side-bar.labels.multiple_claims' | translate }}
      </mat-checkbox>
      <mat-checkbox [checked]="isLabelChecked(tasksLabels.WAITING)"
                    (change)="checkLabel(tasksLabels.WAITING)">{{ 'fnol-request-side-bar.labels.waiting' | translate }}
      </mat-checkbox>
      <mat-checkbox [checked]="isLabelChecked(tasksLabels.SIMPEGO)"
                    (change)="checkLabel(tasksLabels.SIMPEGO)">{{ 'fnol-request-side-bar.labels.simpego' | translate }}
      </mat-checkbox>
      <mat-checkbox [checked]="isLabelChecked(tasksLabels.AGENT)"
                    (change)="checkLabel(tasksLabels.AGENT)">{{ 'fnol-request-side-bar.labels.agent' | translate }}
      </mat-checkbox>
      <mat-checkbox [checked]="isLabelChecked(tasksLabels.POTENTIAL_DUPLICATE)"
                    (change)="checkLabel(tasksLabels.POTENTIAL_DUPLICATE)">{{ 'fnol-request-side-bar.labels.potential_duplicate' | translate }}
      </mat-checkbox>
    </section>
  </div>

  <mat-form-field>
    <mat-label>{{ 'fnol-request-side-bar.reserve-claim-contract-id-label' | translate }}</mat-label>
    <input matInput [(ngModel)]="fnolRequest.mfvReserveClaimContractID" (change)="dropdownValueChanged()">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'fnol-request-side-bar.reserve-claim-id-label' | translate }}</mat-label>
    <input matInput [(ngModel)]="fnolRequest.mfvReserveClaimID" (change)="dropdownValueChanged()">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'fnol-request-side-bar.notes_label' | translate }}</mat-label>
    <textarea matInput [(ngModel)]="fnolRequest.notes" (change)="dropdownValueChanged()" rows="3" placeholder="{{ 'fnol-request-side-bar.notes_label' | translate }}"></textarea>
  </mat-form-field>

  <mat-form-field class="agent-notes-field">
    <mat-label>{{ 'fnol-request-side-bar.notes_agent_label' | translate }}</mat-label>
    <textarea matInput [(ngModel)]="fnolRequest.notesAgent" (change)="dropdownValueChanged()" rows="1" placeholder="{{ 'fnol-request-side-bar.notes_agent_label' | translate }}"></textarea>
  </mat-form-field>

  <div class="info" *ngIf="fnolRequest.initialReserveData">
    <div>
      <label>{{ 'fnol-request-side-bar.api-reserve-contract-id' | translate }}</label>
      <div><span>{{ fnolRequest.initialReserveData.contractID }}</span>
      </div>
    </div>
    <div>
      <label>{{ 'fnol-request-side-bar.api-reserve-full-contract-number' | translate }}</label>
      <div><span>{{ fnolRequest.initialReserveData.fullContractNumber }}</span>
      </div>
    </div>
    <div>
      <label>{{ 'fnol-request-side-bar.api-reserve-claim-id' | translate }}</label>
      <div><span>{{ fnolRequest.initialReserveData.claimID }}</span>
      </div>
    </div>
    <div>
      <label>{{ 'fnol-request-side-bar.api-reserve-claim-number' | translate }}</label>
      <div><span>{{ fnolRequest.initialReserveData.claimNumber }}</span>
      </div>
    </div>
    <div>
      <label>{{ 'fnol-request-side-bar.api-reserve-claim-date' | translate }}</label>
      <div><span>{{ fnolRequest.initialReserveData.claimDate | date:'dd.MM.YYYY' }}</span>
      </div>
    </div>
    <div>
      <label>{{ 'fnol-request-side-bar.api-reserve-claim-type' | translate }}</label>
      <div><span>{{ fnolRequest.initialReserveData.type }}</span>
      </div>
    </div>
    <div>
      <label>{{ 'fnol-request-side-bar.api-reserve-claim-amount' | translate }}</label>
      <div><span>{{ fnolRequest.initialReserveData.amount }}</span>
      </div>
    </div>
    <div>
      <label>{{ 'fnol-request-side-bar.api-reserve-claim-course-of-events' | translate }}</label>
      <div><span>{{ fnolRequest.initialReserveData.courseOfEvents }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="fnolRequest.reserveDuplicateIDs && fnolRequest.reserveDuplicateIDs.length">
    <div class="duplicate-title">{{ 'fnol-request-side-bar.duplicate-title' | translate }}</div>
    <div class="duplicate-value">
      <a *ngFor="let duplicateId of fnolRequest.reserveDuplicateIDs" [href]="linkToFnolRequestById(duplicateId)">
        {{ duplicateId }}
      </a>
    </div>
  </div>

  <button mat-raised-button color="warn"
          (click)="completeFNOLRequestWithoutProcessing()">
    {{ 'fnol-request-side-bar.close-without-processing' | translate }}
  </button>

  <button mat-raised-button color="primary" *ngIf="fnolRequest.processingStatus === 98"
          (click)="reopenFNOLRequest()">
    {{ 'fnol-request-side-bar.reopen' | translate }}
  </button>

  <button mat-raised-button color="primary" [disabled]="disableMarkMultipleButton"
          (click)="markRequestsAsMultipleClaims()">
    {{ 'fnol-request-side-bar.mark-as-multiple' | translate }}
  </button>

  <div class="multiple-claims" *ngIf="fnolRequest.multipleClaimsRef && fnolRequest.multipleClaimsRef.length">
    <div class="multiple-claims-title">{{ 'fnol-request-side-bar.multiple_claims_reference_title' | translate }}</div>
    <div class="multiple-claims-values">
      <div class="multiple-claim-item" *ngFor="let claimPreview of fnolRequest.multipleClaimsRef">
        <a class="multiple-claim" [href]="linkToFnolRequestById(claimPreview.id)">
          {{ claimPreview.id | slice:0:4 }}
        </a>
        <div class="multiple-claim-date">{{ claimPreview.notificationDate | date:'dd.MM.YYYY' }}</div>
        <div class="multiple-claims-name">{{ claimPreview.pet_name }}</div>
      </div>
    </div>
  </div>

  <button mat-raised-button color="primary"
          (click)="duplicate()">
    {{ 'fnol-request-side-bar.duplicate' | translate }}
  </button>

  <div *ngIf="fnolRequest.parentRequestId">
    <div class="duplicate-title">{{ 'fnol-request-side-bar.parent-request-title' | translate }}</div>
    <div class="duplicate-value">
      <a [href]="linkToFnolRequestById(fnolRequest.parentRequestId)">
        {{ 'fnol-request-side-bar.parent-request-value' | translate }}
      </a>
    </div>
  </div>

  <div *ngIf="fnolRequest.clonedRequestIds && fnolRequest.clonedRequestIds.length">
    <div class="duplicate-title">{{ 'fnol-request-side-bar.cloned-requests-title' | translate }}</div>
    <div class="duplicate-value">
      <a *ngFor="let clonedRequestId of fnolRequest.clonedRequestIds" [href]="linkToFnolRequestById(clonedRequestId)">
        {{ clonedRequestId }}
      </a>
    </div>
  </div>

  <div *ngIf="fnolRequest.additionalDocuments && fnolRequest.additionalDocuments.length" class="info invoice-metadata">
    <div>
      <label>{{ 'fnol-request-side-bar.additional-documents-title' | translate }}</label>
    </div>
    <div class="additional-documents-values">
      <div class="additional-document-item" *ngFor="let additionalDocument of fnolRequest.additionalDocuments">
        <span>{{ additionalDocument.s3Id }}</span>
        <div class="additional-document-actions">
          <div class="info-search-div" (click)="openOrDownloadAdditionalDocument(additionalDocument.s3Id)" [title]="'fnol-request-side-bar.download-additional-document' | translate">
            <mat-icon>file_download</mat-icon>
          </div>
          <div class="info-search-div" (click)="deleteAdditionalDocumentConfirmation(additionalDocument.s3Id)" [title]="'fnol-request-side-bar.delete-additional-document' | translate">
            <mat-icon>delete_outline</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="info-search-div upload-additional-document-button" (click)="uploadAdditionalDocument()" [title]="'fnol-request-side-bar.upload-additional-document' | translate">
    <span>{{ 'fnol-request-side-bar.upload-additional-document' | translate }}</span><mat-icon>file_upload</mat-icon>
  </div>

  <div class="info">
    <div>
      <label>{{ 'fnol-request-find.progress-label' | translate }}</label>
      <div><span class="uppercase">{{ getStatusCategory(fnolRequest.processingStatus) | translate }}</span>
      </div>
    </div>
    <div>
      <label>{{ 'fnol-request-list.status-string' | translate }}</label>
      <div><span>{{ getStatusString(fnolRequest.processingStatus) | translate }}</span>
      </div>
    </div>
  </div>

</ng-container>
